export const getUtmList = ($cookies = {}) => {
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

  const utmData = utmKeys.reduce((res, key) => {
    const value = String($cookies.get(key))
    value && res.set(key, value)
    return res
  }, new Map())

  return Object.fromEntries(utmData)
}

export const setUtmCookie = ($cookies, key, value, options = {}) => {
  $cookies.set(key, value, options)
}

export const removeUtmCookie = ($cookies, key, options = {}) => {
  $cookies.remove(key, options)
}
